import * as React from "react";
import Select from "react-select";

interface SelectFieldProps {
  readonly: boolean;
  label: string;
  value: string | string[];
  options: string[];
  onChange: (value: string | string[] | null) => void;
  isMulti?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({ readonly, label, value, options, onChange, isMulti = false }) => {
  const generateSelectOptions = (options: string[]) =>
    options.map((optionName) => ({
      value: optionName,
      label: optionName,
    }));

  const selectOptions = generateSelectOptions(options);

  return (
    <div className="reasoning-tool-stat">
      <span className="reasoning-tool-stat-label">{label}:</span>
      {readonly ? (
        <span className="reasoning-tool-stat-value">
          {Array.isArray(value) ? value.join(", ") || "—" : value || "—"}
        </span>
      ) : (
        <span className="reasoning-tool-stat-value reasoning-tool-item-decision-input">
          <Select
            isMulti={isMulti}
            isClearable={true}
            options={selectOptions}
            value={isMulti 
              ? selectOptions.filter((option) => (value as string[]).includes(option.value))
              : selectOptions.find((option) => option.value === value)
            }
            onChange={(option) => {
              if (isMulti) {
                onChange(option ? (option as any[]).map((o) => o.value) : []);
              } else {
                onChange(option ? (option as any).value : null);
              }
            }}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </span>
      )}
    </div>
  );
};

export default SelectField;
